import React, { useEffect, useState } from 'react';
import { Box, Chip, FormControlLabel } from '@mui/material';
import { DialogBoxComponent } from '../../../components/DialogBox/DialogBoxCard';
import WarningIcon from '@mui/icons-material/Warning';
import { Android12Switch } from '../../../components/ProjectCard/Android12SwitchStyle';
import HttpService from '../../../services/HttpService';
import { ADMIN_PATH } from '../../../url';

const _axios = HttpService.getAxiosClient();

const EmployeePrivilegeUpdate = (props) => {
  const {
    user,
    privilegeKey = 'SELF_APPROVE_LEAVE_WFH',
    label = 'Self Approve Leave and WFH',
  } = props;
  const [open, setOpen] = useState(false);
  const [enabled, setEnabled] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleConfirm = async () => {
    const st = enabled ? 'NO' : 'YES';
    const body = {
      [privilegeKey]: st,
    };
    try {
      const response = await _axios.put(
        `${ADMIN_PATH}/employeePrivilege/${user.id}`,
        body,
      );

      if (response.status === 200) {
        setOpen(false);
        setEnabled(!enabled);
      } else {
        console.error(
          'Failed to update Employee Privileges. Status:',
          response.status,
        );
      }
    } catch (error) {
      console.error('Error updating Employee Privileges:', error);
    }
  };

  useEffect(() => {
    setEnabled(false);
    if (
      user.employeePrivileges &&
      user.employeePrivileges[privilegeKey] === 'YES'
    ) {
      setEnabled(true);
    }
  }, [user, privilegeKey]);

  return (
    <div>
      <Box
        sx={{
          paddingTop: '11px',
          width: '300px',
        }}
      >
        <FormControlLabel
          sx={{ marginLeft: 0, marginRight: 0 }}
          label={
            <Chip label={label} color="primary" variant="outlined" />
          }
          labelPlacement="start"
          control={<Android12Switch color="success" />}
          checked={enabled}
          size="small"
          onChange={() => setOpen(!open)}
        />
      </Box>
      <DialogBoxComponent
        open={open}
        handleClose={handleClose}
        confirmText="Yes"
        cancelText="No"
        content={
          enabled
            ? `Are you sure, you want to remove "${label}" privilege for ${user.firstName} ${user.lastName}?`
            : `Are you sure, you want to give "${label}" privilege to ${user.firstName} ${user.lastName}?`
        }
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        icon={<WarningIcon color="warning" />}
      />
    </div>
  );
};

export default EmployeePrivilegeUpdate;
